import {EventEmitter, Injectable} from "@angular/core";
import {LocalStorage} from "./local-storage";
import {AuthResponse} from "../models/auth-response";

@Injectable()
export class SessionService {
    public readonly loggedinEmitter: EventEmitter<boolean>;

    static _(ls: LocalStorage) {
        return new SessionService(ls);
    }

    constructor(private localStorage: LocalStorage) {
        this.loggedinEmitter = new EventEmitter();
    }

    isLoggedIn(): boolean {
        try {
            // * If this method doesn't throw it means it is loggedin
            this.getAuthObject();
            return true;
        } catch (error) {
            return false;
        }
    }

    getAuthToken(): string {
        try {
            const auth = this.getAuthObject();
            return auth.access_token;
        } catch (error) {
            return null;
        }
    }

    getAuthExpiration(): number {
        try {
            const auth = this.getAuthObject();
            return auth.expires_in;
        } catch (error) {
            return null;
        }
    }

    getAuthObject(): AuthResponse {
        try {
            const authFromLS = this.localStorage.get("auth") as string;

            if (!authFromLS) {
                throw new Error();
            }
            // ! This might throw if authFromLS cannot be constructed into an object
            const authObj = JSON.parse(authFromLS) as AuthResponse;

            if (!authObj.access_token) {
                throw new Error("Token slot is empty.");
            }
            return authObj;
        } catch (err) {
            // * JSON error
            throw err;
        }
    }

    login() {
        this.loggedinEmitter.emit(true);
    }

    logout() {
        this.localStorage.destroy("auth");
        this.loggedinEmitter.emit(false);
    }
}
